/* ============================================================================
   bk-gallery-depth.js — глубина просмотра галереи карточки товара → GA4.

   ЧТО БЫЛО. В AT и ES событий почти нет: 2 и 13 за 90 дней против 2988 / 2943 /
   4319 в DE / FR / IT. Тема, разметка, __BK_PRODUCT, measurement ID и согласие
   на куки во всех шести магазинах совпадают — расхождение рантайма.

   ПРИЧИНА (воспроизведена на живых страницах, scripts/gallery-depth-live.mjs).
   Ровно в AT и ES на странице стоит контейнер Google Tag Manager
   (GTM-PZHQ8VQR и GTM-T3G39SND); в остальных четырёх магазинах GTM нет.
   Когда GTM есть, общий `window.dataLayer` принадлежит ему, и вызов
   `gtag('event', …)` превращается в пользовательское событие контейнера.
   Тега на `gallery_depth` в контейнере нет — событие умирает внутри GTM:
   в dataLayer оно лежит, в сеть не уходит. Замерено: «лежит в dataLayer: ДА,
   gallery_depth ушёл: НЕТ».

   ЧТО НЕ ЛЕЧИТ (проверено, обе попытки на живой странице дали «не ушло»):
     • явный `gtag('config', GA4_ID)` — это тоже всего лишь сообщение для GTM;
     • собственный поток `gtag/js?id=…&l=bkDataLayer` — gtag.js пропускает
       повторную инициализацию measurement ID, уже загруженного на странице:
       очередь остаётся нетронутым массивом (проверено и в AT, и в IT).

   ЧТО ЛЕЧИТ. Событие отправляется ДВУМЯ путями, и в каждом магазине срабатывает
   ровно один:
     1) `gtag('event','gallery_depth', …)` — работает там, где GTM нет
        (DE, FR, IT, CZ): gtag.js сам разбирает dataLayer и шлёт в GA4;
     2) `dataLayer.push({event:'bk_gallery_depth', …})` — для AT и ES.
        В контейнере нужен GA4-тег с триггером Custom Event `bk_gallery_depth`
        (инструкция: theme/GTM_SETUP.md). Там, где GTM нет, эта запись просто
        лежит в массиве: gtag.js не-командные записи игнорирует, двойного
        счёта не будет.

   Проверка после установки:
     node --env-file="E:/busykids/secrets/.env" scripts/gallery-depth-live.mjs \
       --from=shelf-book-toy --group="Книжная полка отдельно"
   Строка «gallery_depth ушёл» должна стать «ДА» на всех пяти рынках.
   ============================================================================ */
(function () {
  var p = window.__BK_PRODUCT;
  if (!p || !p.media_total || !p.ga4_id) return;
  var GA4_ID = p.ga4_id;

  // порядок важен: первый селектор, давший >=2 элемента, и используем
  var SELECTORS = [
    '.product-detail__images .product-detail__image',  // Boost/SWIFT (эта тема)
    '.product-media-wrapper',                          // другие сборки Boost
    '[data-product-media]'                             // общий запасной
  ];

  var nodes = [], maxIndex = 0, sent = false, started = false;

  function analyticsAllowed() {
    try { var cp = window.Shopify && window.Shopify.customerPrivacy;
          return !!cp && cp.analyticsProcessingAllowed(); } catch (e) { return false; }
  }

  function loadGtag(cb) {
    if (window.gtag) return cb();
    var s = document.createElement('script');
    s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    gtag('js', new Date());
    gtag('config', GA4_ID, { send_page_view: false });
    cb();
  }

  function findGallery() {
    for (var i = 0; i < SELECTORS.length; i++) {
      var found = document.querySelectorAll(SELECTORS[i]);
      if (found.length >= 2) { nodes = found; return true; }
    }
    return false;   // галерею не нашли — событие НЕ отправляем
  }

  function observe() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          var i = Array.prototype.indexOf.call(nodes, e.target);
          if (i > maxIndex) maxIndex = i;
        }
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  function send() {
    if (sent || !nodes.length) return;            // без галереи — молчим
    sent = true;
    var params = {
      item_id: String(p.id),
      ean: p.ean || '',
      max_index: maxIndex + 1,
      image_total: nodes.length,                  // фактическое число слайдов
      depth_pct: Math.round((maxIndex + 1) / nodes.length * 100)
    };

    // путь 1 — магазины без GTM (DE, FR, IT, CZ)
    if (window.gtag) gtag('event', 'gallery_depth', params);

    // путь 2 — магазины с GTM (AT, ES): контейнер ловит по имени события
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bk_gallery_depth',
        bk_item_id: params.item_id,
        bk_ean: params.ean,
        bk_max_index: params.max_index,
        bk_image_total: params.image_total,
        bk_depth_pct: params.depth_pct
      });
    } catch (e) { /* dataLayer недоступен — путь 1 уже отработал */ }
  }

  function start() {
    if (started || !analyticsAllowed()) return;
    started = true;
    loadGtag(function () {
      if (!findGallery()) return;                // не нашли — ничего не шлём
      observe();
      addEventListener('pagehide', send);
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') send();
      });
    });
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], start);
  } else { start(); }
  document.addEventListener('visitorConsentCollected', start);
})();
